/**
 * When all the js worked and the page is built, show it
 */
import { GLOBALS } from '../../js/globals';

setTimeout(() => {
    GLOBALS.H.classList.add('_is-preloaded');
}, 500);
